import { useState, useRef, useEffect } from "react";

const capTitle = {
    'all': 'All',
    'player': 'Player',
    'ally': 'Ally',
    'monster': 'Enemy',
}

const EditPositionDropdown = ({creatureType, current, handlePvOptionChange}) => {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(current)
    const dropdownRef = useRef(null);

    useEffect(() => {
        setSelectedOption(current);
    }, [current])

    const handleOptionClick = (newValue, key) => {
        // creatureType = 'players', 'monster', 'ally'
        // key = 'position'
        setSelectedOption(newValue);
        handlePvOptionChange(creatureType, key, newValue)
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="positionContainer" ref={dropdownRef} style={{minWidth: "63px", marginLeft: '5px'}}>
            <div className="positionTitleContainer" style={{outline: open ? "1px solid #919191" : ''}} onClick={() => setOpen(o => !o)}>
                <span style={{paddingLeft: "5px"}}>{selectedOption}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(90deg)",
                    minWidth: "16px",
                    minHeight: "16px"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="#555555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            
            {open && (
                <div className="positionGridContainer" style={{outline: "1px solid #919191"}} >
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div><b>{capTitle[creatureType]} Icon Positions</b>: {selectedOption}</div>
                       
                    </div>
                    <ul className="positionDropdownList">
                        {['Center', 'Top', 'Right', 'Left', 'Bottom'].map((option, i) => (
                            <li key={option+'li'} className="positionDropdownListItem" style={{outline: selectedOption === option ? '3px solid #584f3bff' : '', margin: option === 'Center' ? '0px 40px 0px 40px': '0px 0px 0px 0px'}} onClick={() => handleOptionClick(option, 'position')}>
                                {option}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default EditPositionDropdown;